import styled from "@emotion/styled";
import Button from "@/components/Button";

export const ContactUsWrapper = styled.div`
	display: flex;
`;

export const ContactUsGuideWrapper = styled.div`
	padding: 34px 28px;
	border: 1px solid #e0e0e0;
	width: 420px;
	border-radius: 4px;
	margin-right: 42px;
`;

export const ContactUsGuideTitle = styled.p`
	font-size: 16px;
	line-height: 24px;
	color: #121212;
	margin-bottom: 24px;
`;

export const ContactUsGuideSubTitle = styled.p`
	font-size: 14px;
	line-height: 24px;
	color: #121212;
	font-weight: bold;
	margin-bottom: 10px;
`;

interface ContactUsGuideItemWrapperProps {
	last?: boolean;
}

export const ContactUsGuideItemWrapper = styled.div<ContactUsGuideItemWrapperProps>`
	margin-bottom: ${({ last }) => (last ? 0 : 28)}px;
`;

interface ContactUsGuideTextProps {
	last?: boolean;
}

export const ContactUsGuideText = styled.div<ContactUsGuideTextProps>`
	font-size: 16px;
	margin-bottom: ${({ last }) => (last ? 0 : 6)}px;
	display: flex;
	align-items: center;
`;

export const ContactUsGuideCheck = styled.div`
	width: 24px;
	height: 24px;
	margin-right: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ContactUsGuideContent = styled.div`
	flex-grow: 1;
`;

export const ContactUsSendButton = styled(Button)`
	width: 100%;
`;

export const Form = styled.form`
	width: 100%;
`;
